import { X } from 'lucide-react'
import { AddChip } from '@/components/ui/add-chip'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

export function EventCapacityField({
  capacity,
  soldCount,
  enabled,
  onEnabledChange,
  onCapacityChange,
}: {
  enabled: boolean
  capacity: string
  soldCount: number
  onEnabledChange: (enabled: boolean) => void
  onCapacityChange: (capacity: string) => void
}) {
  return (
    <div>
      {enabled ? (
        <div>
          <div className="flex items-center gap-1">
            <Input
              id="event-capacity"
              inputMode="numeric"
              placeholder="Unlimited"
              className="h-8 w-28 tabular-nums"
              value={capacity}
              onChange={(event) => onCapacityChange(event.target.value)}
            />
            <Button
              type="button"
              variant="outline"
              size="icon"
              className="h-8 w-8 border-transparent p-0 text-muted-foreground"
              aria-label="Remove event capacity"
              onClick={() => onEnabledChange(false)}
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
          <p className="mt-1 text-caption text-muted-foreground">
            Maximum seats across all ticket types. Ticket quantities may add up to more — the event
            capacity wins.
          </p>
          <p className="mt-1 text-caption text-muted-foreground">
            {soldCount} of {capacity} sold
          </p>
        </div>
      ) : (
        <div>
          <AddChip onClick={() => onEnabledChange(true)}>Set an event capacity</AddChip>
          <p className="mt-1 text-caption text-muted-foreground">
            Otherwise seats are limited only by each ticket type&apos;s quantity.
          </p>
          <p className="mt-1 text-caption text-muted-foreground">{soldCount} sold</p>
        </div>
      )}
    </div>
  )
}
